import {UIGameManager} from '../UIGameManager'
import {GameStateEnums} from '../../../../../shared/GameEnums'
import UIGameEventEnums = GameStateEnums.UIGameEventEnums
import {KeyBindController} from '../../KeyBindController'
import {GameAction} from '@colonist/game-base-types'
import {UIGameMechanic} from '../UIGameEventController'
import {BeginnerModeActionState} from '@colonist/game-state-types'
import {AnalyticEventCategory, AnalyticEventType} from '../../../../../shared/entity_datas/EntityDatas'
import {UIInvisibleBackgroundView} from '../ui_game_confirmation/UIInvisibleBackgroundView'
import {AjaxDataTypes} from '../../../../../shared/AjaxDataTypes'
import {CA} from '../../analytics/Analytics'
import {StorageWrapper} from '../../StorageWrapper'
import {BeginnerModeLevel} from '@colonist/game-beginner-mode'
import {UIGameBeginnerModeHelpersController} from './ui_game_beginner_mode_helpers/UIGameBeginnerModeHelpersController'

export class UIGameBeginnerModeController implements UIGameMechanic {
    private readonly uiGameManager: UIGameManager
    private readonly currentLevel: BeginnerModeLevel
    private readonly helpersController: UIGameBeginnerModeHelpersController
    private interactiveBackground: UIInvisibleBackgroundView
    private currentBeginnerModeAction: BeginnerModeActionState
    private isCurrentWelcomeActionSkipped: boolean = false

    constructor(uiGameManager: UIGameManager) {
        this.uiGameManager = uiGameManager
        this.currentLevel = StorageWrapper.getBeginnerModeLevel()
        this.helpersController = new UIGameBeginnerModeHelpersController(uiGameManager, this.currentLevel)
        this.uiGameManager.eventController.sendEvent(undefined, UIGameEventEnums.BeginnerModeStart)
        this.uiGameManager.eventController.registerUIGameMechanic(this)
        KeyBindController.instance.disableKeyBindings()
    }

    onEvent(data: any, eventType: GameStateEnums.UIGameEventEnums) {
        switch(eventType) {
            case UIGameEventEnums.CardAnimationEnd: this.helpersController.updateHelpers(this.currentBeginnerModeAction); break
            case UIGameEventEnums.BeginnerModeActionUpdated: this.onBeginnerModeActionUpdate(data); break
            case UIGameEventEnums.ShowTradeUI: this.restrictCardClickActions(); break
            case UIGameEventEnums.CanvasResized: this.onCanvasResized(); break
            case UIGameEventEnums.BeginnerModeClickedDisabledElement: this.onDisabledElementClick(); break
            default: break
        }
    }

    private onBeginnerModeActionUpdate(data: BeginnerModeActionState) {
        this.currentBeginnerModeAction = data
        this.isCurrentWelcomeActionSkipped = false
        this.sendBeginnerModeAnalytic(data.actionIndex)
        if(this.interactiveBackground == undefined) this.createInteractiveBackground()
        this.helpersController.updateHelpers(data)
    }

    private restrictCardClickActions() {
        if(this.currentBeginnerModeAction == undefined) return
        const cardsPreventedFromTrading = this.currentBeginnerModeAction.resourceCardsPreventedFromTrading
        this.uiGameManager.tradeController.wantedCardSelectorView.removeCardsClickAction(cardsPreventedFromTrading)
    }

    private onDisabledElementClick() {
        if(this.shouldSkipWelcomeAction()) this.uiGameManager.socketGameSend.skipWelcomeActionOnBeginnerMode()
        this.uiGameManager.eventController.sendEvent(this.currentBeginnerModeAction, UIGameEventEnums.BeginnerModeInteractWithGuide)
    }

    private createInteractiveBackground() {
        const mapView = this.uiGameManager.mapController.mapView
        const backgroundClickAction = () => this.onDisabledElementClick()
        this.interactiveBackground = new UIInvisibleBackgroundView(-mapView.worldWidth, -mapView.worldHeight,
            mapView.worldWidth * 2, mapView.worldHeight * 2, mapView.layers.ports, mapView, backgroundClickAction)
        this.interactiveBackground.drawBg()
    }

    private shouldSkipWelcomeAction() {
        if(this.currentBeginnerModeAction.type != GameAction.SkippedWelcome) return false
        if(this.isCurrentWelcomeActionSkipped) return false
        this.isCurrentWelcomeActionSkipped = true
        return true
    }

    private sendBeginnerModeAnalytic(actionIndex: number) {
        const type = this.currentLevel == BeginnerModeLevel.Level1 ? AnalyticEventType.BeginnerModeLevel1 : AnalyticEventType.BeginnerModeLevel2
        const eventData: AjaxDataTypes.AnalyticData = {
            type: type,
            category: AnalyticEventCategory.Game,
            floatValue: actionIndex,
        }
        void CA.sendAnalyticEventOnce(eventData)
    }

    private onCanvasResized() {
        this.restrictCardClickActions()

        this.helpersController.onCanvasResized(this.currentBeginnerModeAction)
    }
}
